import { render } from "./perview.vue?vue&type=template&id=f8d07236&scoped=true"
import script from "./perview.vue?vue&type=script&lang=js"
export * from "./perview.vue?vue&type=script&lang=js"

import "./perview.vue?vue&type=style&index=0&id=f8d07236&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8d07236"]])

export default __exports__